import React, { useState, useEffect } from 'react'
import { Button, Row, Col, message, Modal, Spin, Form, Input } from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { loadSendEmailModalShow } from '../../../appRedux/actions/Sell'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { isEmailValid, notAllowMsgCheck } from '../../../appRedux/actions'

const SendEmailModal = props => {
  const id = props.id ? props.id : false
  const email = props.email ? props.email : false
  const history = useHistory()
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const store = useStore()

  const getReduxEmailModalShow = useSelector(
    ({ Sell }) => Sell.sendEmailModalShow
  )

  const [getIsSpinning, setIsSpinning] = useState(false)

  React.useEffect(() => {
    form.setFieldsValue({ EmailAddress: email ? email : '' })
  }, [email])

  async function postEmailAddress (body) {
    const postEmail = ds.postSendReceiptEmailService(body, BEHAVIOUR_TYPE.POST)
    await postEmail
      .then(res => {
        setIsSpinning(false)
        dispatch(loadSendEmailModalShow(false))
        if (res.includes('uccess')) {
          message.success('Successfully Sent Email')
        }
        if (res.includes('ailed')) {
          message.info('Email Sending Failed')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsSpinning(false)
        dispatch(loadSendEmailModalShow(false))
      })
  }

  const onFinish = values => {
    // ;
    if (id) {
      setIsSpinning(true)
      let body = {
        ToEmailAddress: values.EmailAddress,
        SalesOrderID: id
      }
      postEmailAddress(body)
    } else {
      message.error('Kindly Retry Later')
    }
  }

  const onFinishFailed = errorInfo => {
    //;
    message.error('Kindly Attend To Missing Field')
  }

  return (
    <div className="gx-main-content-wrapper">
      <Modal className="EmailReceipt-Modal"
        title={
          <strong><IntlMessages id="sell.salehistory.sendemail" /></strong>
        }
        centered
        visible={getReduxEmailModalShow}
        // width={1000}
        footer={null}
        onCancel={() => dispatch(loadSendEmailModalShow(false))}
      >
        <Spin
          tip={<IntlMessages id="sell.cashlisting.cashloading" />}
          spinning={getIsSpinning}
          size="large"
        >
          <div>
            <Form className=" col-pad-label"
              name="SendEmailForm"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
              layout="vertical"
            >
              <Row>
                <Col span={24}>
                  <Form.Item
                    name="EmailAddress"
                    label={
                      <IntlMessages id="sell.salehistory.emailaddress" />
                    }
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                      {
                        validator: isEmailValid,
                      },
                    ]}
                  >
                    <Input className="w-100" size="large" />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="end">
                <Col span={24} className="text-right">
                  <Button
                    className="dk-btn-add"
                    type="primary"
                    htmlType="submit"
                  >
                    <IntlMessages id="sell.salehistory.sendemail" />
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

export default SendEmailModal
